/*!

=========================================================
* Argon Design System React - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link, withRouter } from "react-router-dom";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  UncontrolledCollapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col
} from "reactstrap";

class DemoNavbar extends React.Component {
  componentDidMount() {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
  }
  state = {
    collapseClasses: "",
    collapseOpen: false
  };

  onExiting = () => {
    this.setState({
      collapseClasses: "collapsing-out"
    });
  };

  onExited = () => {
    this.setState({
      collapseClasses: ""
    });
  };

  render() {
    return (
      <>
        <header className="header-global">
          <Navbar
            className="navbar-main navbar-transparent navbar-light headroom"
            expand="lg"
            id="navbar-main"
          >
            <Container className="d-flex align-items-center justify-content-between">
              <Link to="/" className="navbar-brand d-flex align-items-center" style={{padding: 0}}>
                <img
                  alt="Chisp"
                  src={require("assets/img/brand/chisp.png")}
                  style={{ height: "36px", width: "auto", alignSelf: 'center', margin: 0, padding: 0, filter: 'brightness(0) invert(1)' }}
                />
              </Link>
              <button className="navbar-toggler" id="navbar_global">
                <span className="navbar-toggler-icon" />
              </button>
              <UncontrolledCollapse
                toggler="#navbar_global"
                navbar
                className={this.state.collapseClasses}
                onExiting={this.onExiting}
                onExited={this.onExited}
              >
                <div className="navbar-collapse-header">
                  <Row>
                    <Col className="collapse-brand" xs="6">
                      <Link to="/">
                        <img
                          alt="Chisp"
                          src={require("assets/img/brand/Chisp_logo_white_outer.png")}
                          style={{ height: "40px", width: "auto", display: 'block', margin: '0' }}
                        />
                      </Link>
                    </Col>
                    <Col className="collapse-close" xs="6">
                      <button className="navbar-toggler" id="navbar_global">
                        <span />
                        <span />
                      </button>
                    </Col>
                  </Row>
                </div>
                <Nav className="navbar-nav-hover align-items-lg-center ml-auto justify-content-end" navbar>
                  <NavItem>
                    <NavLink to="/" tag={Link} className="chisp-navbar-link">
                      <i className="fa fa-home d-lg-none mr-1" />
                      <span className="nav-link-inner--text">Home</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/consulting" tag={Link} className="chisp-navbar-link">
                      <i className="fa fa-database d-lg-none mr-1" />
                      <span className="nav-link-inner--text">Data Consulting</span>
                    </NavLink>
                  </NavItem>
                  <NavItem className="dropdown chisp-subnav">
                    <NavLink to="/platform" tag={Link} className="chisp-navbar-link">
                      <i className="fa fa-sitemap d-lg-none mr-1" />
                      <span className="nav-link-inner--text">IoT Platform</span>
                      <i className="fa fa-angle-down ml-1 d-none d-lg-inline" />
                    </NavLink>
                    <div className="dropdown-menu">
                      <Link className="dropdown-item" to="/industrial">
                        <i className="fa fa-industry text-primary" />
                        Industrial Monitoring
                      </Link>
                      <Link className="dropdown-item" to="/home">
                        <i className="fa fa-home text-success" />
                        Home Connectivity
                      </Link>
                      <Link className="dropdown-item" to="/data-analytics">
                        <i className="fa fa-line-chart text-info" />
                        Platform Analytics
                      </Link>
                    </div>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/about" tag={Link} className="chisp-navbar-link">
                      <i className="ni ni-single-02 d-lg-none mr-1" />
                      <span className="nav-link-inner--text">About</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/contact" tag={Link} className="chisp-navbar-link">
                      <i className="fa fa-envelope d-lg-none mr-1" />
                      <span className="nav-link-inner--text">Contact Us</span>
                    </NavLink>
                  </NavItem>
                </Nav>
              </UncontrolledCollapse>
            </Container>
          </Navbar>
        </header>
      </>
    );
  }
}

export default withRouter(DemoNavbar);
